import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./ProgressBarTable.module.scss";

const salesData = [
    { name: "AS Store", percentage: 90, color: "#0095FF", bg: "#CDE7FF", text: "#0095FF" },
    { name: "DS Store", percentage: 29, color: "#00E096", bg: "#8CFAC7", text: "#00E58F" },
    { name: "GH Store", percentage: 18, color: "#884DFF", bg: "#C5A8FF", text: "#884DFF" },
    { name: "NT Store", percentage: 13, color: "#FF8F0D", bg: "#FFD5A4", text: "#FF8900" },
];

const SalesProgressBar = () => {
    return (
        <div className="sales-container">
            <table className="table">
                <thead>
                    <tr>
                        <th style={{ backgroundColor: "#F8F8F8", padding: "10px", color: "#8E95A9", border: "none" }}>Name</th>
                        <th style={{ backgroundColor: "#F8F8F8", padding: "10px", color: "#8E95A9", border: "none" }}>Sales</th>
                        <th style={{ backgroundColor: "#F8F8F8", padding: "10px", color: "#8E95A9", border: "none" }}></th>
                    </tr>
                </thead>

                <tbody>
                    {salesData.map((store, index) => (
                        <tr key={index}>
                            <td style={{ border: "none" }}>{store.name}</td>
                            <td style={{ border: "none" }}> 
                                <div className="progress-container">
                                    <div
                                        className="progress"
                                        style={{
                                            backgroundColor: `${store.bg}`, // Lighter background of same color
                                            height: 8,
                                            marginTop: 10
                                        }}
                                    >
                                        <div
                                            className="progress-bar"
                                            style={{
                                                width: `${store.percentage}%`,
                                                backgroundColor: store.color,
                                                height: 8
                                            }}
                                        ></div>
                                    </div>
                                    <span
                                        className="badge"
                                        style={{ borderColor: store.color, color: store.color }}
                                    >
                                        {/* {store.percentage}% */}
                                    </span>
                                </div>
                            </td>
                            <td style={{



                                border: "none",
                                width: "20%"
                                // borderColor:
                            }}>
                                <div
                                    style={{
                                        backgroundColor: store.bg,
                                        textAlign: "center",
                                        padding: 4,
                                        color: store.text,
                                        fontSize: "14px",
                                        borderRadius: 10,
                                        border: `1px solid ${store.text}`, // Correct way to apply border color
                                    }}
                                >
                                    {store.percentage}%
                                </div>

                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div >
    );
};

export default SalesProgressBar;
